import useSelectedPharmacy from './useSelectedPharmacy';
import useUserRoles from './useUserRoles';

interface PaymentOverdueState {
  isBlocked: boolean;
  primaryUserEmail: string | undefined;
}

export default function usePaymentOverdue(): PaymentOverdueState {
  const selectedPharmacy = useSelectedPharmacy();
  const { isSupport } = useUserRoles();

  const isOverdue = selectedPharmacy?.chain?.saas_billing?.payment_overdue === true;

  return {
    isBlocked: isOverdue && !isSupport,
    primaryUserEmail: selectedPharmacy?.chain?.primaryUser?.email,
  };
}
